import React from 'react';
import Button from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const ViewGuide = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 py-12">
      <div className="max-w-xl w-full bg-surface border border-border rounded-xl shadow-elevation-1 p-8">
        <div className="flex flex-col items-center mb-6">
          <Icon name="Book" size={40} className="text-primary mb-2" />
          <h1 className="text-2xl font-bold mb-2 text-text-primary">Troubleshooting Guide</h1>
          <p className="text-text-secondary text-center mb-4">
            Having trouble connecting your accounts? Here are some common solutions:
          </p>
        </div>
        <ul className="list-disc pl-6 text-text-secondary space-y-2 mb-6">
          <li>Ensure you are logged into the correct Spotify or Google account in your browser.</li>
          <li>Clear your browser cache and cookies, then try again.</li>
          <li>Make sure you have granted all required permissions during the OAuth process.</li>
          <li>Disable browser extensions that may block popups or cookies.</li>
          <li>If you see an error, try disconnecting and reconnecting your account.</li>
        </ul>
        <Button fullWidth variant="primary" size="md" iconName="ArrowLeft" iconSize={18} onClick={() => navigate(-1)}>
          Back to Account Connection
        </Button>
      </div>
    </div>
  );
};

export default ViewGuide; 